import { Cid10, TamanhoFraldaGeriatricaEnum, TipoAtestadoEnum } from 'graphql/types.generated'
import { SoapEditableItem } from 'view/atendimentos/atendimento-individual/model'

export default interface AtestadoModel extends SoapEditableItem {
  tipo?: TipoAtestadoEnum
  descricao?: string
  assinadoDigitalmente?: boolean
  cpfCns?: string
  naoPossui?: boolean
  data?: LocalDate
  hora?: string
  cid10?: Cid10
  dias?: number
  tamanhoFralda?: TamanhoFraldaGeriatricaEnum
  unidadesPorDia?: number
}

export type CidadaoAtestado = {
  id: ID
  cpf?: string
  cns?: string
  nome: string
  nomeSocial?: string
}

export enum AtestadoModeloEnum {
  PADRAO,
  EM_BRANCO,
  LICENCA_MATERNIDADE,
  SOLICITACAO_FRALDAS_GERIATRICAS,
  PERSONALIZADO,
}

export type AtestadoSelectModel = {
  tipo: AtestadoModeloEnum
  nome: string
  id?: ID
}

export const atestadoSelectModelDefaultRecord: Record<
  Exclude<AtestadoModeloEnum, AtestadoModeloEnum.PERSONALIZADO>,
  AtestadoSelectModel
> = {
  [AtestadoModeloEnum.PADRAO]: {
    tipo: AtestadoModeloEnum.PADRAO,
    nome: 'Padrão',
  },
  [AtestadoModeloEnum.EM_BRANCO]: {
    tipo: AtestadoModeloEnum.EM_BRANCO,
    nome: 'Em branco',
  },
  [AtestadoModeloEnum.LICENCA_MATERNIDADE]: {
    tipo: AtestadoModeloEnum.LICENCA_MATERNIDADE,
    nome: 'Licença-maternidade',
  },
  [AtestadoModeloEnum.SOLICITACAO_FRALDAS_GERIATRICAS]: {
    tipo: AtestadoModeloEnum.SOLICITACAO_FRALDAS_GERIATRICAS,
    nome: 'Solicitação de fraldas geriátricas',
  },
}
